import { render, staticRenderFns } from "./customer_count.vue?vue&type=template&id=5357cc6c&scoped=true&"
import script from "./customer_count.vue?vue&type=script&lang=js&"
export * from "./customer_count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5357cc6c",
  null
  
)

export default component.exports